import { render, staticRenderFns } from "./updatePublisher.vue?vue&type=template&id=20fdc6b1&"
import script from "./updatePublisher.vue?vue&type=script&lang=js&"
export * from "./updatePublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports